import { Section } from '../components/Section/Section'
import { useMetricsSummary } from 'hooks/queries/useMetricsSummary'
import useURLParams from 'hooks/useURLParams'
import Styles from './Summary.module.scss'
import { SummaryItem } from './SummaryItem'
import PostNow from 'blaze-ui/icons/32/PostNow'
import { HighDetailedFollowers } from 'blaze-ui/icons/20/HighDetailedFollowers'
import { formatValue } from 'screens/blaze/Home/components/Analytics/utils'
import { useAnalyticsContext } from '../AnalyticsContext'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { PeriodSelect } from '../components/PeriodSelect/PeriodSelect'

const defaultData = {
  current_period: null,
  previous_period: null,
}

export const Summary = () => {
  const { period, setPeriod } = useAnalyticsContext()
  const [searchParams] = useURLParams()
  const { isMobile } = useResponsiveDesign()
  const { data, isFetching } = useMetricsSummary({
    period,
    externalIntegrationId: parseInt(searchParams.get('external_integration_id') as string),
  })

  const iconSize = isMobile ? 32 : 46

  return (
    <Section
      title="Summary"
      actions={isMobile && <PeriodSelect variant="tertiary" period={period} onPeriodChange={setPeriod} />}
    >
      <div className={Styles.summary}>
        <SummaryItem
          name="Total Posts"
          data={data?.total_posts || defaultData}
          icon={<PostNow size={iconSize} />}
          isFetching={isFetching}
        />
        <div className={Styles.divider} />
        <SummaryItem
          name="New Followers"
          data={data?.followers || defaultData}
          icon={<HighDetailedFollowers size={iconSize} />}
          isFetching={isFetching}
          valueFormatter={formatValue}
        />
      </div>
    </Section>
  )
}
